export default __webpack_public_path__ + "static/media/logo.047c7636.png";